"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uncrunch = void 0;
const tslib_1 = require("tslib");
const crunch_1 = require("./crunch");
require("./JSON");
const v1 = (0, tslib_1.__importStar)(require("./v1"));
const v2 = (0, tslib_1.__importStar)(require("./v2"));
function uncrunch(data) {
  if (!(0, crunch_1.isVersionedCrunchedData)(data)) {
    return v1.uncrunch(data);
  }
  if (data.version === 2) {
    return v2.uncrunch(data.crunched);
  }
  throw new Error(`Unsupported version ${data.version}`);
}
exports.uncrunch = uncrunch;